import { render, staticRenderFns } from "./GiftPointsCard.vue?vue&type=template&id=60bf814c&scoped=true"
import script from "./GiftPointsCard.vue?vue&type=script&lang=js"
export * from "./GiftPointsCard.vue?vue&type=script&lang=js"
import style0 from "./GiftPointsCard.vue?vue&type=style&index=0&id=60bf814c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bf814c",
  null
  
)

export default component.exports